/**
 * NO04 - Ordre Search Action Types
 */

export const NO04_SEARCH_REQUEST = 'NO04_SEARCH_REQUEST';
export const NO04_SEARCH_SUCCESS = 'NO04_SEARCH_SUCCESS';
export const NO04_SEARCH_FAILURE = 'NO04_SEARCH_FAILURE';

export const NO04_LOAD_MORE_REQUEST = 'NO04_LOAD_MORE_REQUEST';
export const NO04_LOAD_MORE_SUCCESS = 'NO04_LOAD_MORE_SUCCESS';
export const NO04_LOAD_MORE_FAILURE = 'NO04_LOAD_MORE_FAILURE';

export const NO04_CLEAR_RESULTS = 'NO04_CLEAR_RESULTS';
export const NO04_CLEAR_COMPONENT_STORE = 'NO04_CLEAR_COMPONENT_STORE';

export const NO04_ORDER_DETAIL_REQUEST = 'NO04_ORDER_DETAIL_REQUEST';
export const NO04_ORDER_DETAIL_SUCCESS = 'NO04_ORDER_DETAIL_SUCCESS';
export const NO04_ORDER_DETAIL_FAILURE = 'NO04_ORDER_DETAIL_FAILURE';
export const NO04_ORDER_DETAIL_CLEAR = 'NO04_ORDER_DETAIL_CLEAR';
